import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router'
import router from './router'

// Import du store Vuex
import store from './store'

import VueLodash from "vue-lodash"
import lodash from 'lodash'

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';

import Cookies from 'js-cookie'

import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
const company = process.env.VUE_APP_COMPANY;
console.log(company)
if (company === "bdsh") {
        import('@amsom-habitat/bootstrap-5/dist/bootstrap.bdsh.min.css')
} else {
        import('@amsom-habitat/bootstrap-5/dist/bootstrap.min.css')
}

import userManager from "@amsom-habitat/user-manager"
const defaultDomain = process.env.VUE_APP_DEFAULT_DOMAIN ?? false
const cookies = Cookies.withAttributes({ path: '/', domain: userManager.getDomain() })

// Page de login par office/environnement (cf. Cally) : la valeur était codée en dur, donc
// l'outil renvoyait toujours vers son propre /login au lieu du login cockpit.
userManager.setLoginPageUrl(process.env.VUE_APP_LOGIN_PAGE_URL ?? '/login')
userManager.setRoleHierarchy({"ROLE_ADMIN": ["ROLE_USER", "ROLE_SLS", "ROLE_GMBI", "ROLE_ASSURANCE", "ROLE_MODIFICATION_INDIVIDU", "ROLE_PRELEVEMENT", "ROLE_FACTURATION_BADGE"]})
userManager.setRoleKey("sollicitation")
if(defaultDomain)
    userManager.setDefaultDomain(defaultDomain)

Vue.use(VueToast)

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)


// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// import on your project (less then 1KB gziped)
import vueSmoothScroll from 'vue-smooth-scroll'
Vue.use(vueSmoothScroll)

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueLodash, {lodash: lodash})
//Moment (date)
Vue.use(require('vue-moment'));

//Défini les filtres pour l'ensemble de la vue
Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString().toLowerCase();
    return value.charAt(0).toUpperCase() + value.slice(1)
  })

Vue.prototype.$userManager = userManager
Vue.prototype.$cookies = cookies
Vue.prototype.$officeName = process.env.VUE_APP_OFFICE_NAME

export const bus = new Vue();
new Vue({
    created() {
        const html = document.documentElement // returns the html tag
        html.setAttribute('lang', 'fr')
    },
    el: '#app',
    router,
    store,
    render: h => h(App),
})
